import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function CreationsPage() {
  const categories = [
    {
      id: 'livres',
      name: 'Livres Personnalisés',
      description: 'Histoires magiques où votre enfant devient le héros de l\'aventure',
      icon: '📚',
      gradient: 'from-blue-400 to-blue-600',
      products: [
        {
          id: 1,
          name: 'Histoire de Noël Personnalisée',
          price: '29.90',
          image: 'https://public.readdy.ai/ai/img_res/e8f92163cd4ef920968e99ae65d50c54.jpg',
        },
        {
          id: 2,
          name: 'Aventure dans l\'Espace',
          price: '29.90',
          image: 'https://readdy.ai/api/search-image?query=A%20space%20adventure%20storybook%20showing%20a%20child%20astronaut%20exploring%20colorful%20planets%20with%20friendly%20aliens%2C%20stars%20and%20rockets%2C%20Pixar%20Disney%20style%2C%20vibrant%20cosmic%20colors%2C%20simple%20background%2C%20exciting%20atmosphere&width=400&height=500&seq=spacebook1&orientation=portrait',
        },
        {
          id: 3,
          name: 'Royaume des Princesses',
          price: '29.90',
          image: 'https://readdy.ai/api/search-image?query=A%20princess%20kingdom%20storybook%20with%20a%20child%20character%20in%20a%20magical%20castle%20with%20unicorns%20and%20fairies%2C%20pastel%20colors%2C%20sparkles%2C%20Pixar%20Disney%20style%2C%20simple%20clean%20background%2C%20enchanting%20fairytale%20atmosphere&width=400&height=500&seq=princessbook1&orientation=portrait',
        },
      ],
    },
    {
      id: 'personnages',
      name: 'Personnages Animés',
      description: 'Transformez vos proches en adorables personnages de dessin animé',
      icon: '🎭',
      gradient: 'from-purple-400 to-pink-600',
      products: [
        {
          id: 4,
          name: 'Portrait Famille Animé',
          price: '39.90',
          image: 'https://readdy.ai/api/search-image?query=An%20animated%20family%20portrait%20in%20Pixar%20Disney%20style%20showing%20happy%20parents%20with%20children%2C%20colorful%20outfits%2C%20warm%20expressions%2C%20simple%20pastel%20background%2C%20professional%203D%20rendering%2C%20heartwarming%20scene&width=400&height=500&seq=famchar1&orientation=portrait',
        },
        {
          id: 5,
          name: 'Personnage Enfant 3D',
          price: '34.90',
          image: 'https://readdy.ai/api/search-image?query=A%20cute%203D%20animated%20child%20character%20in%20Pixar%20Disney%20style%20with%20big%20expressive%20eyes%2C%20playful%20pose%2C%20colorful%20clothing%2C%20simple%20gradient%20background%2C%20professional%20quality%2C%20charming%20personality&width=400&height=500&seq=kidchar1&orientation=portrait',
        },
        {
          id: 6,
          name: 'Couple Animé',
          price: '39.90',
          image: 'https://readdy.ai/api/search-image?query=An%20animated%20couple%20portrait%20in%20Pixar%20Disney%20style%20showing%20two%20people%20in%20love%2C%20romantic%20pose%2C%20warm%20colors%2C%20simple%20soft%20background%2C%20professional%20illustration%2C%20heartwarming%20scene&width=400&height=500&seq=couplechar1&orientation=portrait',
        },
      ],
    },
    {
      id: 'invitations',
      name: 'Invitations Animées',
      description: 'Invitations uniques et mémorables pour tous vos événements spéciaux',
      icon: '💌',
      gradient: 'from-yellow-400 to-orange-500',
      products: [
        {
          id: 7,
          name: 'Invitation Anniversaire Vidéo',
          price: '24.90',
          image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20animated%20birthday%20invitation%20with%20balloons%20cake%20candles%20and%20party%20decorations%2C%20bright%20cheerful%20colors%2C%20Pixar%20Disney%20style%2C%20simple%20clean%20background%2C%20festive%20celebration%20elements&width=400&height=500&seq=birthinvite1&orientation=portrait',
        },
        {
          id: 8,
          name: 'Faire-part Naissance',
          price: '24.90',
          image: 'https://readdy.ai/api/search-image?query=A%20sweet%20baby%20announcement%20card%20with%20cute%20baby%20elements%2C%20soft%20pastel%20colors%2C%20stars%20and%20clouds%2C%20Pixar%20Disney%20style%2C%20simple%20clean%20background%2C%20tender%20and%20joyful%20atmosphere&width=400&height=500&seq=babyinvite1&orientation=portrait',
        },
        {
          id: 9,
          name: 'Invitation Mariage',
          price: '29.90',
          image: 'https://readdy.ai/api/search-image?query=An%20elegant%20wedding%20invitation%20with%20romantic%20elements%2C%20flowers%20and%20hearts%2C%20soft%20elegant%20colors%2C%20Pixar%20Disney%20style%2C%20simple%20clean%20background%2C%20romantic%20and%20magical%20atmosphere&width=400&height=500&seq=weddinginvite1&orientation=portrait',
        },
      ],
    },
    {
      id: 'portraits',
      name: 'Portraits Illustrés',
      description: 'Portraits artistiques de votre famille, couples et animaux de compagnie',
      icon: '🎨',
      gradient: 'from-green-400 to-teal-600',
      products: [
        {
          id: 10,
          name: 'Portrait Famille Illustré',
          price: '39.90',
          image: 'https://readdy.ai/api/search-image?query=An%20illustrated%20family%20portrait%20in%20Pixar%20Disney%20style%20showing%20parents%20children%20and%20a%20pet%2C%20warm%20colors%2C%20simple%20soft%20background%2C%20artistic%20rendering%2C%20heartwarming%20scene%2C%20professional%20quality&width=400&height=500&seq=famport1&orientation=portrait',
        },
        {
          id: 11,
          name: 'Portrait avec Animal',
          price: '34.90',
          image: 'https://readdy.ai/api/search-image?query=An%20illustrated%20portrait%20of%20a%20person%20with%20their%20pet%20dog%20in%20Pixar%20Disney%20style%2C%20loving%20scene%2C%20warm%20colors%2C%20simple%20background%2C%20artistic%20quality%2C%20heartwarming%20atmosphere&width=400&height=500&seq=petport1&orientation=portrait',
        },
        {
          id: 12,
          name: 'Avatar Personnalisé',
          price: '19.90',
          image: 'https://readdy.ai/api/search-image?query=A%20personalized%20avatar%20illustration%20in%20Pixar%20Disney%20style%20showing%20a%20person%20with%20unique%20style%2C%20colorful%20outfit%2C%20simple%20gradient%20background%2C%20professional%20quality%2C%20expressive%20character&width=400&height=500&seq=avatar1&orientation=portrait',
        },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h1 className="text-6xl font-fredoka font-bold text-gray-900 mb-6">
              Nos Créations{' '}
              <span className="bg-gradient-to-r from-primary-blue via-purple-600 to-primary-coral bg-clip-text text-transparent">
                Magiques
              </span>
            </h1>
            <p className="text-xl font-quicksand text-gray-600 max-w-3xl mx-auto">
              Découvrez toutes nos catégories de créations numériques personnalisées pour créer des souvenirs inoubliables
            </p>
          </motion.div>
        </div>
      </section>

      {/* Categories Sections */}
      {categories.map((category, categoryIndex) => (
        <section
          key={category.id}
          className={`py-20 ${categoryIndex % 2 === 0 ? 'bg-white' : 'bg-neutral-lighter'}`}
        >
          <div className="max-w-7xl mx-auto px-6">
            {/* Category Header */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="mb-12"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${category.gradient} rounded-2xl shadow-soft`}>
                  <span className="text-3xl">{category.icon}</span>
                </div>
                <div>
                  <h2 className="text-4xl font-fredoka font-bold text-gray-900">
                    {category.name}
                  </h2>
                  <p className="font-quicksand text-gray-600 mt-1">
                    {category.description}
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Products Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {category.products.map((product, productIndex) => (
                <motion.div
                  key={product.id}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: productIndex * 0.1 }}
                >
                  <Link
                    to={`/produit/${product.id}`}
                    className="group block bg-white rounded-3xl overflow-hidden shadow-soft hover:shadow-soft-lg transition-all duration-300 hover:-translate-y-2 cursor-pointer"
                  >
                    {/* Image */}
                    <div className="relative w-full h-80 overflow-hidden">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>

                    {/* Content */}
                    <div className="p-6">
                      <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-3">
                        {product.name}
                      </h3>
                      <div className="flex items-center justify-between mb-4">
                        <div>
                          <div className="text-xs font-quicksand text-gray-500 mb-1">
                            À partir de
                          </div>
                          <div className="text-3xl font-fredoka font-bold text-gray-900">
                            {product.price}€
                          </div>
                        </div>
                      </div>
                      <button className="w-full px-6 py-3 bg-gray-900 text-white font-quicksand font-semibold rounded-full group-hover:bg-primary-blue transition-all duration-300 whitespace-nowrap flex items-center justify-center gap-2">
                        <i className="ri-sparkling-fill"></i>
                        <span>Personnaliser</span>
                      </button>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      ))}

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-primary-blue via-purple-600 to-primary-coral">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-5xl font-fredoka font-bold text-white mb-6">
              Vous ne trouvez pas ce que vous cherchez ?
            </h2>
            <p className="text-xl font-quicksand text-white/90 mb-10">
              Contactez-nous pour une création sur mesure adaptée à vos besoins
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-3 px-10 py-5 bg-white text-gray-900 font-quicksand font-bold text-lg rounded-full hover:shadow-soft-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span>Nous contacter</span>
              <i className="ri-mail-line text-xl"></i>
            </Link>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}